const autofillformRoutes = [
  {
    path: '/autofillform/createAutofillform',
    name: '表单创建',
    component: () => import('@/views/autofillform/createAutofillform')
  }, {
    path: '/autofillform/formManage',
    name: '表单触发管理',
    component: () => import('@/views/autofillform/formManage')
  }, {
    path: '/autofillform/testTool',
    name: '测试工具',
    component: () => import('@/views/autofillform/testTool')
  }, {
    path: '/autofillform/kms',
    name: '知识',
    component: () => import('@/views/autofillform/kms')
  }, {
    path: '/autofillform/list',
    name: '填单列表',
    component: () => import('@/views/autofillform/list')
  }
]
export default autofillformRoutes
